import { useParams } from "react-router";
import { AlertSettingsWidget } from "@gf-alerting/widgets";
import { TableWrapper, Wrapper } from "./AlertSettingsTab.styles";

export default function AlertSettingsTab() {
  const { deviceId } = useParams();

  return (
    <Wrapper>
      <TableWrapper>
        <AlertSettingsWidget
          deviceId={deviceId as string}
          cellStyles={{ height: 48, minHeight: 48 }}
          saveImmediately
          useStatusToggle
          showNotificationChannels
        />
      </TableWrapper>
    </Wrapper>
  );
}
